import { Component, OnInit, Input, HostBinding, Output, EventEmitter } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AddEditHierarchyComponent } from '../../pages/profile/Profile Popups/add-edit-hierarchy/add-edit-hierarchy.component';
import { ProfileService } from '../../services/profile.service';
import { InviteUserComponent } from '../../pages/profile/Profile Popups/invite-user/invite-user.component';
import { BubbleService } from '../../services/bubble.service';
@Component({
  selector: 'bubble-tree-ui',
  templateUrl: './bubble-tree-ui.component.html',
  styleUrls: ['./bubble-tree-ui.component.scss']
})
export class BubbleTreeUiComponent implements OnInit {

  // static members
  public static treeRecursiveOperationException = false;

  //Input data to manipulate bubble tree data and features
  @Input() levelData: any; // Input data
  @Input() level: number; // Level of bubble tree
  @Input() addNode: boolean; // add remove add button
  @Input() editNode: boolean; // add remove edit button
  @Input() delNode: boolean; // add remove delete button
  @Input() isActiveNode: boolean; // add remove active inactive checkbox
  @Input() disableDragDrop: boolean; // enable disable drag drop feature
  @Input() lastNode: number; // Number of levels to show (If set to -1 tree can go to n levels)
  @Input() isSelected: number // Number of level from which nodes can be selected (If -1 then no node will have select option)

  @Output()
  callEvent = new EventEmitter<String>();
  // Instance members
  networkJson: any;
  levelKey: any = null;
  initialTree: any;
  // Tree drag and drop config
  draggable = {
    // note that data is handled with JSON.stringify/JSON.parse
    // only set simple data or POJO's as methods will be lost
    'data': null,
    'effectAllowed': 'all',
    'disable': false,
    'handle': false
  };
  serviceData: any;
  subScriptionType: any;
  standerdSubScription: boolean;
  premierSubcription: boolean;

  constructor(
    public dialog: MatDialog,
    private profileService: ProfileService,
    private bubbleService: BubbleService
  ) { }

  ngOnInit() {
    this.setExpandedTreeLevel();
    this.draggable.disable = this.disableDragDrop;
    this.subScriptionType = JSON.parse(sessionStorage.getItem('userDetails')).subScriptionType;
    if (this.subScriptionType == 'standard') {
      this.standerdSubScription = true;
      this.premierSubcription = false;

    } else if (this.subScriptionType == 'premier') {
      this.premierSubcription = true;
      this.standerdSubScription = true;
    } else {
      this.premierSubcription = false;
      this.standerdSubScription = false;
    }
  }
  //method to set level of tree
  setExpandedTreeLevel() {
    let expandArr = JSON.parse(sessionStorage.getItem('expandedLayer'));
    this.level = this.level + 1;
    this.levelKey = expandArr[this.level - 1];
  }

  showNetwork(jsonObj) {
    // Restrict method execution (Expanding tree) if node is last node or node is not active or node is having no childrens
    if (
      this.level == this.lastNode
      || !(jsonObj.deleted == 0)
      || !(jsonObj.children != null && jsonObj.children[0] != undefined)) {
      return false;
    }

    let expandArr = JSON.parse(sessionStorage.getItem('expandedLayer'));
    sessionStorage.setItem('parentSelected', jsonObj.customerName);
    if (this.levelKey == null) {
      this.levelKey = jsonObj.customerKey;
      expandArr.push(jsonObj.customerKey);
    }
    else if (this.levelKey == jsonObj.customerKey) {
      this.levelKey = null;
      expandArr = expandArr.slice(0, this.level - 1);
    }
    else {
      this.levelKey = jsonObj.customerKey;
      if (this.level > expandArr.length) {
        expandArr.push(jsonObj.customerKey);
      } else {
        expandArr = expandArr.slice(0, this.level - 1);
        expandArr.push(jsonObj.customerKey);
      }
    }
    sessionStorage.setItem('expandedLayer', JSON.stringify(expandArr));
  }


  addUser(jsonObj) {
    let dialogRef = this.dialog.open(InviteUserComponent, {
      hasBackdrop: true,
      backdropClass: 'cdk-overlay-transparent-backdrop',
      width: '50%',
      data: { userData: 0, hierarchyData: jsonObj, isBubbleCall: 1 }
    });
  }

  addChild(jsonObj) {
    let dialogRef = this.dialog.open(AddEditHierarchyComponent, {
      hasBackdrop: true,
      width: '80%',
      position: {
        top: '1%'
      },
      data: { userData: 0, hierarchyData: jsonObj, isBubbleCall: 1 }
    });

    dialogRef.componentInstance.onHierarchyUpdate.subscribe(() => {
      this.getHierarchyDetails();
    });

  }

  getHierarchyDetails() {
    this.bubbleService.setBubbleLoader(true);
    this.profileService.getHierarchyDetails(sessionStorage.getItem('legacyCustomerKeyId')).subscribe(result => {
      const userDetails = JSON.parse(sessionStorage.getItem('userDetails'));
      this.serviceData =
        [
          {
            'customerKey': sessionStorage.getItem('legacyCustomerKeyId'),
            'customerName': sessionStorage.getItem('companyName'),
            'hierarchy': 'Corporate',
            'reportTo': sessionStorage.getItem('companyName'),
            'externalId': sessionStorage.getItem('legacyCustomerKeyId'),
            'address': '',
            'dayPhone': userDetails.breakDownPhone,
            'nightPhone': '',
            'responsibleParty': '',
            'phone': '',
            'subCustomerKey': null,
            'divisionKey': null,
            'icon': null,
            'level': 1,
            'deleted': 0,
            'parentKey': null,
            'children': result
          }
        ];

      localStorage.setItem('serviceNetwork', JSON.stringify(this.serviceData));
      this.bubbleService.setBubbleTreeData();
      this.bubbleService.setBubbleLoader(false);
    });
  }

  deletedHierarchy(value) {
    const data = {
      'userAssociation': value.customerKey,
      'userHierarchy': value.hierarchy
    }
    this.bubbleService.setBubbleLoader(true);
    this.profileService.deleteUserHierarchy(data).subscribe(() => {
      this.getHierarchyDetails();
    }, (error) => {
      this.bubbleService.setBubbleLoader(false);
      console.error('BubbleTreeUiComponent_deletedHierarchy', error);
    });
  }

}
